import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { Inventory } from '@mui/icons-material';

const Products = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Products
      </Typography>
      <Paper
        sx={{
          p: 8,
          textAlign: 'center',
          backgroundColor: '#f5f5f5'
        }}
      >
        <Inventory sx={{ fontSize: 80, color: 'text.secondary', mb: 2 }} />
        <Typography variant="h5" color="textSecondary" gutterBottom>
          Feature Under Development
        </Typography>
        <Typography variant="body1" color="textSecondary">
          Product and category management coming soon
        </Typography>
      </Paper>
    </Box>
  );
};

export default Products;
